"use strict";

exports.__esModule = true;
exports.default = void 0;

var renderImage = function renderImage(ctx, node) {
  if (!node.image.data) return;
  var _node$props = node.props,
      x = _node$props.x,
      y = _node$props.y;
  var _node$style = node.style,
      width = _node$style.width,
      height = _node$style.height,
      opacity = _node$style.opacity;
  var paddingTop = node.box.paddingLeft || 0;
  var paddingLeft = node.box.paddingLeft || 0;

  if (width === 0 || height === 0) {
    console.warn("Image with src '" + node.props.href + "' skipped due to invalid dimensions");
    return;
  }

  ctx.save();
  ctx.fillOpacity(opacity || 1).image(node.image.data, x + paddingLeft, y + paddingTop, {
    width: width,
    height: height
  });
  ctx.restore();
};

var _default = renderImage;
exports.default = _default;